export var WorkflowAttachmentType;
(function (WorkflowAttachmentType) {
    WorkflowAttachmentType["Overlay"] = "overlay";
    WorkflowAttachmentType["Instructions"] = "instructions";
})(WorkflowAttachmentType || (WorkflowAttachmentType = {}));
